import { gql } from '@apollo/client';
import { AccountFragment } from '../account/Account';

export const OrganizationPersonFragment = gql`
  fragment OrganizationPerson on OrganizationPerson {
    firstName
    lastName
    immutableId
    email
    status
    creationDate
    domain
    identityDirectories
    subscribedAccounts {
      ...Account
    }
    administratedAccounts {
      ...Account
    }
  }
  ${AccountFragment}
`;
